import { UNSET_REFETCH_ACTIONABLES } from 'actions';

export default function unsetFetchActionables() {
  return {
    type: UNSET_REFETCH_ACTIONABLES,
  };
}
